module.exports = __webpack_public_path__ + "img/logo.63da3da9.png";